<script>
import { mapActions, mapState } from 'vuex';

export default {
    props: {
        selectedCompanyId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            isEnterprise: false,
            
            publishedReportBefore: false,
            sustReportCount: 1,

            languageOptions: [
                {key: 'en', val: false},
                {key: 'tr', val: false},
            ]
        }
    },

    computed: {
		...mapState('settings', [
			'steps'
		]),
    },

    mounted() {
        this.initializeStatus();
    },

    methods: {
        ...mapActions('company', [
            'getCompanyPlan',
            'getCompanyReportPublishingStatus',
            'updateReportsPublished',
            'updateReportLanguages',
        ]),

        ...mapActions('app', [
            'setSelectedReportLanguages'
        ]),

        _getCompanyPlan() {
            this.getCompanyPlan()
                .then(res => {
                    if (res.data.plan_id === 4) {
                        this.isEnterprise = true;
                    }
                })
        },

        _getCompanyReportPublishingStatus() {
            this.getCompanyReportPublishingStatus()
                .then(res => {
                    if (res.data.reports_published > 0) {
                        this.publishedReportBefore = true;
                        this.sustReportCount = res.data.reports_published;
                    }

                    let initial_languages = [];
                    for (let i = 0; i < res.data.report_languages_selected.length; i++) {
                        const idx = this.languageOptions.findIndex(x => x.key === res.data.report_languages_selected[i]);
                        if (idx !== -1) {
                            this.languageOptions[idx].val = true;
                        }

                        if (res.data.report_languages_selected[i]) {
                            initial_languages.push(res.data.report_languages_selected[i]);
                        }
                    }
                    this.setSelectedReportLanguages(initial_languages);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },

        initializeStatus() {
            this._getCompanyPlan();
            this._getCompanyReportPublishingStatus();
        },

        _updateReportsPublished() {
            if (this.sustReportCount < 1) {
                return;
            }

            const params = {
                reports_published: this.sustReportCount
            }

            this.updateReportsPublished(params)
                .then(() => {
                    this.updateProcessTracking();
                    this.$notify('success', '', true);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },

        _updateReportLanguages(action, language) {
            const params = {
                action: action === true ? 'append' : 'remove',
                language: language
            }

            this.updateReportLanguages(params)
                .then(() => {
                    const selected_languages = this.languageOptions.filter(x => x.val === true);

                    this.setSelectedReportLanguages(selected_languages.map(x => x.key));
                    this.$notify('success', '', true);
                })
                .catch(({ response }) => {
                    this.$notify('success', response.data.messageName);
                })
        },

        // handler //

        handleChangePublishedReportBefore(e) {
            if (e.target.checked === false) {
                this.sustReportCount = 0;
                this.updateReportsPublished({reports_published: 0});
                this.updateProcessTracking();
            } else {
                this.sustReportCount = 1;
                this.updateReportsPublished({reports_published: 1});
                this.updateProcessTracking();
            }
        },

        // aftermath //

        updateProcessTracking() {
            if (this.sustReportCount == 0) {
                this.steps[1].skippable = false;
                this.steps[2].skippable = false;
                this.steps[3].skippable = false;
                this.steps[4].skippable = false;
                this.steps[5].skippable = false;
                this.steps[6].skippable = false;
                this.steps[7].skippable = false;
                this.steps[8].skippable = false;
                this.steps[9].skippable = false;
            } else {
                this.steps[1].skippable = true;
                this.steps[2].skippable = true;
                this.steps[3].skippable = true;
                this.steps[4].skippable = true;
                this.steps[5].skippable = true;
                this.steps[6].skippable = true;
                this.steps[7].skippable = true;
                this.steps[8].skippable = true;
                this.steps[9].skippable = true;
            }
        }
    }
}
</script>

<template>
    <div class="report-options">
        <div class="question" v-if="isEnterprise">
            <label for="published-report">
                {{ $t('companyProfile.reportStatus._1') }}
            </label>
            <input type="checkbox" id="published-report" v-model="publishedReportBefore" @change="handleChangePublishedReportBefore($event)">
        </div>

        <div class="question" v-if="publishedReportBefore">
            <label for="input">
                {{ $t('companyProfile.reportStatus._2') }}
            </label>
            <input type="number" name="input" v-model="sustReportCount" @change="_updateReportsPublished()">
        </div>

        <div class="language-options">
            <div class="question">
                {{ $t('companyProfile.reportStatus._3') }}
            </div>
            
            <div class="options">
                <div v-for="opt in languageOptions" :key="opt.key"
                    class="option"
                >
                    <input type="checkbox" :id="`language-${opt.key}`" v-model="opt.val"
                        @change="_updateReportLanguages(opt.val, opt.key)"
                    >
                    <label :for="`language-${opt.key}`">
                        {{ opt.key }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang='scss' scoped>
.report-options {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: flex-start;
    
    >.question {
        margin-bottom: 1em;
        width: 60%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        border-bottom: thin solid lightgray;
    
        >label {
            padding-right: .5em;
            margin: 0 !important;
            font-weight: bold;
        }

        > input[type="checkbox"] {
            max-width: 1vw !important;
        }
        
        > input[type="number"] {
            max-width: 50px !important;
        }
    }
}


.language-options {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;;

    > .question {
        color: black;
        font-weight: bold;

        > input {
            max-width: 10px !important;
        }
    }

    > .options {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        > .option {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;

            > label {
                margin: 0 !important;
                font-weight: bold;
                text-transform: uppercase;
            }
            
            > input {
                margin-right: .5em;
                align-self: center;
            }
        }
    }
}

input,
select {
    padding: .25em;
    border: thin solid rgb(235, 235, 235);
    border-bottom: thin solid lightgray !important;
    background-color: rgb(242, 242, 242);
    max-width: 75px;
    text-align: center;

    transition: border-bottom 500ms;

    &:focus {
        border-bottom: thin solid black !important;
    }

    &:disabled {
        border-radius: .2em;
        background-color: rgb(221, 221, 221);
        cursor: not-allowed;
    }
}

input[type='number'] {
    -moz-appearance: textfield;
    appearance: textfield;

    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
}

label {
    color: black !important;
}
</style>
